// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"8a0566c4","297":"d48157ed","643":"b9380cd7","787":"26a71e92"}[chunkId] + ".chunk.js";
};